import React, { Component } from 'react';

// An unhandled render error on one page shows an inline message instead of blanking the whole site. The menu and top bar stay outside it
// (see V3Shell) so a person can always navigate away, and the shell keys it on the path so a crashed page does not hide the next one.
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('V3: unhandled render error:', error, info && info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="card" role="alert">
          <div className="card-head"><h3>Something went wrong on this page</h3></div>
          <div className="card-body">
            <p style={{ color: 'var(--text-dim)', marginBottom: 12 }}>{this.state.error.message}</p>
            <button type="button" className="btn btn-primary" onClick={() => this.setState({ error: null })}>Try again</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
